// extracted by mini-css-extract-plugin
module.exports = {"decoratorList":"decorator-list_decoratorList__2odI9"};